import { FormPanelDiscardCopy } from "./types";

const EDIT_COPY: FormPanelDiscardCopy = {
  title: "Discard your changes?",
  confirmLabel: "Discard changes",
};

export const discardCopyOf = (
  isEdit: boolean,
  noun: string,
): FormPanelDiscardCopy =>
  isEdit
    ? EDIT_COPY
    : { title: `Cancel new ${noun}?`, confirmLabel: "Discard" };
